import { Button } from '../Input2';
import { General } from '../StrokeIcons';

import Popup, { type PopupProps } from './Popup';

type ClonePopupProps = PopupProps & {
  onClone: (id: string, title: string) => void;
  title?: string;
  id?: string;
};

export default function ClonePopup({ onClose, onClone, title, id }: ClonePopupProps) {
  return (
    <Popup onClose={onClose} className="w-1/2">
      <h2 className="text-xl font-bold">Clone Graph</h2>
      <p>Enter an ID for the cloned graph</p>
      <form
        className="flex flex-col gap-4"
        onSubmit={(e) => {
          e.preventDefault();
          const formData = new FormData(e.currentTarget);
          const id = formData.get('id') as string;
          const title = formData.get('title') as string;
          if (id && title) onClone(id, title);
        }}>
        <div className="flex flex-col gap-2">
          <input
            name="id"
            type="text"
            placeholder="Enter clone ID"
            className="rounded-sm border border-gray-300 px-3 py-2"
            defaultValue={id}
            required
          />
        </div>
        <div className="flex flex-col gap-2">
          <input
            name="title"
            type="text"
            placeholder="Enter clone ID"
            className="rounded-sm border border-gray-300 px-3 py-2"
            defaultValue={title}
            required
          />
        </div>
        <Button icon={<General.PlusCircle />} color="blue">
          Clone Graph
        </Button>
      </form>
    </Popup>
  );
}

